export type CoinBadgeProps = {
  value?: number;
  onClick?: () => void;
};

const CoinBadge: React.FC<CoinBadgeProps> = ({ value, onClick }) => {
  return (
    <div onClick={onClick} className="bg-badge-bg-strong flex items-center gap-[var(--spacing-xs)] rounded-full p-[var(--spacing-sm)] pe-[var(--spacing-md)]">
      <img src="/imgweb/main/coin.png" alt="coin" className="h-[16px] w-[16px]" />
      <div className="typography-body-sm min-w-[16px] text-end text-base-txt-white">{value || MyDataManager.getCoin()}</div>
    </div>
  );
};

export default CoinBadge;
